export default __webpack_public_path__ + "static/media/LAR_placeholder.42e4a176.svg";